import React from 'react';
import ReactDOM from 'react-dom';
import SetMfa from './SetMfa.tsx';
import AuthService from '../../../auth/auth.service';

export default angular
  .module('components.tb.setMfa', ['react'])
  .directive('tbSetMfa', (reactDirective, $auth, $state, $stateParams, AuthService) => reactDirective(SetMfa, [], {}, { $auth, $state, $stateParams, AuthService }))